import { baseUrl, GetHeaders, handleResponse, handleError } from "../common/ApiUtils";

const apiUrl = baseUrl + "RevShareEarnedHoursCalculator/";

export function getCalculableQuarters() {
  return fetch(`${apiUrl}accrue/calculable`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function calculateAccruedRevShareForQuarter(quarter, year) {
  return fetch(`${apiUrl}accrue/${year}/${quarter}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export const getAccrualCalculatorRunHistory = () => {
  return fetch(`${apiUrl}accrue/history`, GetHeaders()).then(handleResponse).catch(handleError);
};
